import { useCallback } from 'react';
import { useMutation } from 'src/graphql';
import {
  ADD_TAG_VERSION_MUTATION,
  CREATE_TAG_MUTATION,
} from 'src/graphql/tag/mutation';

export default isNew => {
  const mutation = isNew ? CREATE_TAG_MUTATION : ADD_TAG_VERSION_MUTATION;
  const [upsertTag] = useMutation(mutation);

  return useCallback(
    ({
      tagId,
      name,
      publish,
      ...rest
    }) =>
      upsertTag({
        variables: {
          tagId,
          name,
          publish,
          ...rest,
        },
      }),
    [],
  );
};
